import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos - dados ficam "frescos"
      gcTime: 10 * 60 * 1000, // 10 minutos - garbage collection (antes era cacheTime)
      refetchOnWindowFocus: false, // Não refetch ao focar janela
      refetchOnReconnect: true, // Refetch ao reconectar
      retry: 1, // Tentar 1 vez em caso de erro
    },
  },
});
